import React from 'react';
import './DayHead.css';
import { MONTHS, START_TIME, WEEKDAYS } from '../../../../../constants';

// todo - entry.time as key is not ideal

function DayHead({ currentDayId, startDayId, weekdayId }) {
  // todo - temp solution for first week
  const dayId = startDayId + weekdayId;

  let dayClass = 'program-day-head';
  const dayDate = new Date(START_TIME + dayId * 24 * 60 * 60 * 1000);

  if (dayId % 7 === 6) {
    dayClass += ' sunday';
  }

  if (dayId === currentDayId) {
    dayClass += ' current';
  }

  return (
    <div className={dayClass}>
      <h4>{WEEKDAYS[dayId % 7]}</h4>
      <div className="date">{`${dayDate.getDate()}. ${
        MONTHS[dayDate.getMonth()]
      } 1968`}</div>
    </div>
  );
}

export default DayHead;



// WEBPACK FOOTER //
// ./src/components/App/Program/Head/DayHead/DayHead.js